import React from 'react';
import Avatar from 'features/shared/components/avatar/Avatar';
import { CustomerType } from '../enums/customerType';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface Props {
  customerType: CustomerType;
  size: number;
  iconSize?: number;
  disableShadow?: boolean; 
}

const CustomerAvatar = (props: Props) => {
  // helpers
  const getIcon = (customerType: CustomerType): IconProp => {
    switch (customerType) {
      case CustomerType.Company:
        return "building";
      case CustomerType.Person:
        return "user";
      default:
        return "ban";
    }
  }

  // render
  return (
    <Avatar icon={getIcon(props.customerType)} {...props} />
  )
}

export default CustomerAvatar;
